import ButtonBack from '../../components/ButtonBack'
import { TransactionsChart } from '../Dashboard/components/TransactionChart/TransactionsChart'
import {
  addMoneySimbols,
  addMoneySimbolsCents,
} from '../../../app/utils/formatMoneyValue'
import { Moneys, Personalcard } from 'iconsax-react'
import { FormProvider } from 'react-hook-form'
import TableTransactions from './components/TableTransactions'
import CustomerDetails from './components/CustomerDetails'
import Tab from './components/Tab'
import Card from '../../components/Card'
import useWithdrawSimulation from './useWithdrawSimulation'
import { Dialog } from '../../components/ui/dialog'
import MakeProposalCard from './components/MakeProposalCard'
import NewWithdrawModal from './components/NewWithdrawModal'
import { Spinner } from '../../components/ui/spinner'
import Loading from './components/Loading'
import { EmptyMessage } from '../../components/EmptyMessage'
import { formatCpfNumber } from '../../../app/utils/cpfFormater'
import { Table } from 'lucide-react'
import { TableCard } from './components/TableCard'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/view/components/ui/select'

export default function WithdrawSimulation() {
  const {
    form,
    cpf,
    setSelectedTab,
    setSkip,
    tabs,
    transactionChart,
    transactions,
    availableCredit,
    customer,
    selectedTable,
    setSelectedTable,
    quotas,
    handleQuotaChange,
  } = useWithdrawSimulation()

  const { data, isLoading } = transactionChart
  const { data: availabeData, isLoading: availabeIsLoading } = availableCredit
  const { data: transactionsData, isLoading: transactionsIsLoading } =
    transactions

  const tables = availabeData?.tables

  return (
    <div>
      <ButtonBack label={customer?.data?.name ?? formatCpfNumber(cpf || '')} />
      <div className="flex flex-col gap-8 xl:flex-row">
        <section className="flex flex-col gap-5 rounded-2xl border-gray01 sm:min-w-[461px] sm:p-0 md:border md:p-5">
          <Card className="flex grow flex-row items-start justify-between">
            <div>
              {!availabeIsLoading &&
                (selectedTable?.ValorLiquidoCliente || 0) > 0 && (
                  <p className="mb-4 text-sm font-normal text-black04">
                    Saldo disponível para saque
                  </p>
                )}

              {availabeIsLoading ? (
                <Spinner />
              ) : (selectedTable?.ValorLiquidoCliente || 0) > 0 ? (
                <h3 className="text-4xl font-normal text-black01">
                  {selectedTable?.amount
                    ? addMoneySimbolsCents(selectedTable.amount)
                    : addMoneySimbols(selectedTable?.ValorLiquidoCliente || 0)}
                </h3>
              ) : (
                <div className="flex flex-col gap-2">
                  <p className="font-semibold text-black02 sm:text-lg md:text-2xl">
                    {selectedTable?.message}
                  </p>
                </div>
              )}
            </div>

            {!availabeIsLoading &&
              (selectedTable?.ValorLiquidoCliente || 0) > 0 && (
                <div>
                  <p className="mb-4 text-sm font-normal text-black04">
                    Parcelas
                  </p>
                  <Select
                    defaultValue={tables ? tables?.[0]?.Prazo?.toString() : ''}
                    onValueChange={handleQuotaChange}
                  >
                    <SelectTrigger className="w-16 text-lg">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {quotas.map((quota) => (
                        <SelectItem
                          className="text-lg"
                          key={quota.value}
                          value={quota.value.toString()}
                          onClick={(e: React.MouseEvent) => e.stopPropagation()}
                        >
                          {quota.label}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}
          </Card>

          <Dialog>
            <MakeProposalCard
              disabled={
                (selectedTable?.amount
                  ? selectedTable.amount / 100
                  : selectedTable?.ValorLiquidoCliente) === 0 ||
                availabeIsLoading
              }
            />
            <NewWithdrawModal table={selectedTable} />
          </Dialog>
        </section>
        <section className="hidden w-full rounded-2xl border border-gray01 p-5 lg:block">
          <TransactionsChart data={data} isLoading={isLoading} />
        </section>
      </div>
      <div className="mt-8">
        <div className="z-10 flex overflow-x-auto border-b">
          <Tab onSelect={() => setSelectedTab(0)} isActive={tabs.tables}>
            <Table /> Tabelas
          </Tab>

          <Tab onSelect={() => setSelectedTab(1)} isActive={tabs.transaction}>
            <Moneys /> Transações
          </Tab>

          <div className="min-w-[245px]">
            <Tab
              onSelect={() => setSelectedTab(2)}
              isActive={tabs.personalInfo}
            >
              <Personalcard /> Informações pessoais
            </Tab>
          </div>
        </div>

        {tabs.transaction &&
          (transactionsIsLoading ? (
            <Loading />
          ) : transactionsData?.transactions?.length &&
            transactionsData?.transactions?.length > 0 ? (
            <TableTransactions data={transactionsData} setSkip={setSkip} />
          ) : (
            <EmptyMessage description="Aqui será exibido o histórico de transações do cliente, você poderá acompanhar o progresso e o historico deste cliete." />
          ))}

        {tabs.personalInfo &&
          (customer.isLoading ? (
            <Loading />
          ) : customer.data ? (
            <FormProvider {...form}>
              <CustomerDetails />
            </FormProvider>
          ) : (
            <EmptyMessage description="Aqui será exibido as informações do cliente, para que você possa validar tais informações" />
          ))}

        {tabs.tables &&
          (availabeIsLoading ? (
            <Loading />
          ) : tables && tables.length > 1 && tables?.[0].success ? (
            <div className="flex gap-4 overflow-x-auto p-4 max-sm:snap-x max-sm:snap-mandatory">
              {tables.map((table) => (
                <div
                  key={table.IDTabela}
                  className="max-sm:flex-shrink-0 max-sm:snap-center"
                >
                  <TableCard
                    isSelected={selectedTable?.IDTabela === table.IDTabela}
                    onClick={() => setSelectedTable(table)}
                    table={table}
                  />
                </div>
              ))}
            </div>
          ) : (
            <EmptyMessage
              icon={<Table size={64} />}
              title="Nenhuma tabela encontrada"
              description={tables?.[0]?.message}
            />
          ))}
      </div>
    </div>
  )
}
